// updaters/PdarProbabilityFieldUpdater.ts
import type { Map as MapType } from "maplibre-gl";
import type { MapUpdater, UpdaterContext } from "./types";
import type { ProbabilityGridPayload } from "../types";
import type { PdarProbabilityFieldManager } from "../managers/pdarProbabilityField/PdarProbabilityFieldManager";

export class PdarProbabilityFieldUpdater implements MapUpdater {
  readonly name = "pdarProbabilityField";
  readonly topics = ["probability-grid:batch"];

  private manager: PdarProbabilityFieldManager | null = null;

  constructor(private ctx: UpdaterContext) {}

  async initialise(map: MapType) {
    console.log("[PdarProbabilityFieldUpdater] Initializing...");
  }

  // Called by MapEngine once PdarProbabilityFieldManager is created.
  setManager(manager: PdarProbabilityFieldManager) {
    this.manager = manager;
    console.log("[PdarProbabilityFieldUpdater] PdarProbabilityFieldManager connected");
  }

  async handleMessage(topic: string, payload: any) {
    if (!this.manager) {
      console.warn(
        "[PdarProbabilityFieldUpdater] Message dropped: PdarProbabilityFieldManager not connected",
      );
      return;
    }
    if (topic !== "probability-grid:batch") return;

    const gridPayload: ProbabilityGridPayload = {
      targets: Array.isArray(payload?.targets) ? payload.targets : [],
    };

    this.manager.updateBatch(gridPayload);
  }

  destroy() {
    this.manager = null;
  }
}
